<template>
  <div class="container-fluid py-4">
    <h1 class="h3 mb-4">
      <i class="bi bi-journal-text me-2"></i>
      Logs del Sistema
    </h1>
    <div class="card">
      <div class="card-body">
        <p class="text-muted">Visualizador de logs en desarrollo...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogsView'
}
</script>
